import React, { useEffect, useState } from "react";
import { BASE_URL } from "../env";
import { store } from "react-notifications-component";

const QuestionForm = () => {
	const [name, setname] = useState("");
	const [desc, setdesc] = useState("");
	const [input, setinput] = useState("");
	const [output, setoutput] = useState("");
	const [weigh, setweigh] = useState("");
	const [codeArr, setcodeArr] = useState([{ code: "", language: "" }]);
	const [language, setlanguage] = useState("");
	const [code, setcode] = useState("");

	const [Ptestcases, setPtestcases] = useState([
		{ name: "", code: "", output: "", language: "python" },
	]);
	const [Ctestcases, setCtestcases] = useState([
		{ name: "", code: "", output: "", language: "c" },
	]);
	const [CPPtestcases, setCPPtestcases] = useState([
		{ name: "", code: "", output: "", language: "cpp" },
	]);
	const [Jtestcases, setJtestcases] = useState([
		{ name: "", code: "", output: "", language: "java" },
	]);

	const [Cname, setCname] = useState("");
	const [Ccode, setCcode] = useState("");
	const [Coutput, setCoutput] = useState("");

	const [CPPname, setCPPname] = useState("");
	const [CPPcode, setCPPcode] = useState("");
	const [CPPoutput, setCPPoutput] = useState("");

	const [Pname, setPname] = useState("");
	const [Pcode, setPcode] = useState("");
	const [Poutput, setPoutput] = useState("");

	const [Jname, setJname] = useState("");
	const [Jcode, setJcode] = useState("");
	const [Joutput, setJoutput] = useState("");

	const [course, setcourse] = useState("");
	const [courses, setCourses] = useState([]);

	useEffect(() => {
		fetch(BASE_URL + "/getallCourse")
			.then((res) => res.json())
			.then((data) => {
				setCourses(data?.courses);
				// console.log(data?.courses);
			});
	}, []);

	useEffect(() => {
		fetch(BASE_URL + "/GetAllQuestionAdmin", {
			headers: {
				"Content-Type": "Application/json",
			},
		}).then((res) => res.json());
		// .then((data) => console.log(data));
	}, []);

	const submitHandler = () => {
		//     console.log(name,desc,code,cases,input,output,weigh)
		// const testcases = [Ptestcases, Ctestcases, CPPtestcases, Jtestcases];
		// console.log("TC", testcases);
		// console.log("CA",codeArr)
		const notifyPopup = () => {
			store.addNotification({
				title: "Success!",
				message: "Form Submitted Successfully!",
				type: "success",
				background: "pink",
				insert: "bottom",
				container: "bottom-right",
				animationIn: ["animate__animated", "animate__fadeIn"],
				animationOut: ["animate__animated", "animate__fadeOut"],
				dismiss: {
					duration: 3000,
					onScreen: true,
				},
			});
		};
		fetch(BASE_URL + "/createQuestion", {
			method: "POST",
			headers: {
				"Content-Type": "Application/json",
			},
			body: JSON.stringify({
				name: name,
				description: desc,
				sampleInput: input,
				sampleOutput: output,
				questionCode: codeArr,
				questionWeigh: weigh,
				courseId: course,
				testcases: [Ptestcases, Ctestcases, CPPtestcases, Jtestcases],
			}),
		})
			.then((res) => res.json())
			.then((data) => {
				notifyPopup();
				console.log(data);
			})
			.catch((err) => console.log(err));
	};

	//   const handleChangeInput = (id, event) => {
	//     const newInputFields = inputFields.map(i => {
	//       if(id === i.id) {
	//         i[event.target.name] = event.target.value
	//       }
	//       return i;
	//     })

	//     setInputFields(newInputFields);
	//   }

	const handleAddFields = () => {
		setcodeArr((prev) => [...prev, { code, language }]);
	};

	const handleRemoveFields = (id) => {
		const values = [...codeArr];
		values.splice(
			values.findIndex((value) => value.id === id),
			1
		);
		setcodeArr(values);
	};

	const handleAddPFields = () => {
		setPtestcases([
			...Ptestcases,
			{ name: Pname, code: Pcode, output: Poutput, language: "Python" },
		]);
	};

	const handleRemovePFields = (id) => {
		const values = [...Ptestcases];
		values.splice(
			values.findIndex((value) => value.id === id),
			1
		);
		setPtestcases(values);
	};

	const handleAddCFields = () => {
		setCtestcases([
			...Ctestcases,
			{ name: Cname, code: Ccode, output: Coutput, language: "C" },
		]);
	};

	const handleRemoveCFields = (id) => {
		const values = [...Ctestcases];
		values.splice(
			values.findIndex((value) => value.id === id),
			1
		);
		setCtestcases(values);
	};

	const handleAddCPPFields = () => {
		setCPPtestcases([
			...CPPtestcases,
			{
				name: CPPname,
				code: CPPcode,
				output: CPPoutput,
				language: "C++",
			},
		]);
	};

	const handleRemoveCPPFields = (id) => {
		const values = [...CPPtestcases];
		values.splice(
			values.findIndex((value) => value.id === id),
			1
		);
		setCPPtestcases(values);
	};

	const handleAddJFields = () => {
		setJtestcases([
			...Jtestcases,
			{ name: Jname, code: Jcode, output: Joutput, language: "Java" },
		]);
	};

	const handleRemoveJFields = (id) => {
		const values = [...Jtestcases];
		values.splice(
			values.findIndex((value) => value.id === id),
			1
		);
		setJtestcases(values);
	};
	return (
		<div className="m-5 p-5">
			<h2 style={{ textAlign: "center" }}>Coding Question Form</h2>
			<h4>Course Id:</h4>{" "}
			<select
				className={`form-control`}
				aria-label="Default select example"
				name=""
				id=""
				value={course}
				onChange={(e) => {
					setcourse(e.target.value);
				}}
			>
				<option value="">Select Course</option>
				{courses.map((val) => {
					return <option value={val?._id}>{val?.name}</option>;
				})}
			</select>
			<h4>Name:</h4>{" "}
			{/* <form className="m-5 p-5" onSubmit={(e)=>submitHandler(e)}> */}
			<input
				type="text"
				placeholder="name"
				onChange={(e) => setname(e.target.value)}
			/>
			<br />
			<h4>Description:</h4>
			<input
				type="text"
				placeholder="description"
				onChange={(e) => setdesc(e.target.value)}
			/>
			<br />
			<h4>Input:</h4>
			<input
				type="text"
				placeholder="input"
				onChange={(e) => setinput(e.target.value)}
			/>
			<br />
			<h4>Output:</h4>
			<input
				type="text"
				placeholder="output"
				onChange={(e) => setoutput(e.target.value)}
			/>
			<br />
			<br />
			<h2>Question Code Array:</h2>
			<br />
			{codeArr.map((inputField) => (
				<div key={inputField.id}>
					<p>Code:</p>{" "}
					<textarea
						rows="4"
						cols="100"
						name="code"
						placeholder="Code"
						required
						onChange={(event) => setcode(event.target.value)}
					/>
					<br />
					<p>Language:</p>
					<input
						name="language"
						placeholder="language"
						required
						onChange={(event) => setlanguage(event.target.value)}
					/>
					&emsp;
					<button onClick={handleAddFields}>++</button>
					&emsp;
					<button
						// disabled={inputFields.length === 1}
						onClick={() => handleRemoveFields(codeArr.id)}
					>
						--
					</button>
				</div>
			))}
			<br />
			<h2>Question Weight:</h2>
			<br />
			<input
				type="number"
				placeholder="question weigh"
				onChange={(e) => setweigh(e.target.value)}
			/>
			<br />
			<br />
			<br />
			<h2>Python Test Cases Array:</h2>
			<br />
			{Ptestcases.map((inputField) => (
				<div key={inputField.id}>
					<p>Code:</p>
					<textarea
						rows="4"
						style={{ width: "100%" }}
						name="Pcode"
						placeholder="PCode"
						onChange={(event) => setPcode(event.target.value)}
					/>
					<br />
					<p>Name:</p>
					<input
						name="Pname"
						placeholder="Pname"
						onChange={(event) => setPname(event.target.value)}
					/>{" "}
					<br />
					<p>Output:</p>
					<input
						name="Poutput"
						placeholder="Poutput"
						onChange={(event) => setPoutput(event.target.value)}
					/>
					&emsp;
					<button onClick={handleAddPFields}>++</button>
					&emsp;
					<button
						// disabled={inputFields.length === 1}
						onClick={() => handleRemovePFields(codeArr.id)}
					>
						--
					</button>
				</div>
			))}
			<br />
			<br />
			<h2>C Test Cases Array:</h2>
			<br />
			{Ctestcases.map((inputField) => (
				<div key={inputField.id}>
					<p>Code:</p>
					<textarea
						rows="4"
						style={{ width: "100%" }}
						name="Ccode"
						placeholder="CCode"
						onChange={(event) => setCcode(event.target.value)}
					/>
					<br />
					<p>Name:</p>
					<input
						name="Cname"
						placeholder="Cname"
						onChange={(event) => setCname(event.target.value)}
					/>{" "}
					<br />
					<p>Output:</p>
					<input
						name="Coutput"
						placeholder="Coutput"
						onChange={(event) => setCoutput(event.target.value)}
					/>
					&emsp;
					<button onClick={handleAddCFields}>++</button>
					&emsp;
					<button
						// disabled={inputFields.length === 1}
						onClick={() => handleRemoveCFields(codeArr.id)}
					>
						--
					</button>
				</div>
			))}
			<br />
			<br />
			<h2>CPP Test Cases Array:</h2>
			<br />
			{CPPtestcases.map((inputField) => (
				<div key={inputField.id}>
					<p>Code:</p>
					<textarea
						rows="4"
						style={{ width: "100%" }}
						name="CPPcode"
						placeholder="CPPCode"
						onChange={(event) => setCPPcode(event.target.value)}
					/>
					<br />
					<p>Name:</p>
					<input
						name="CPPname"
						placeholder="CPPname"
						onChange={(event) => setCPPname(event.target.value)}
					/>{" "}
					<br />
					<p>Output:</p>
					<input
						name="CPPoutput"
						placeholder="CPPoutput"
						onChange={(event) => setCPPoutput(event.target.value)}
					/>
					&emsp;
					<button onClick={handleAddCPPFields}>++</button>
					&emsp;
					<button
						// disabled={inputFields.length === 1}
						onClick={() => handleRemoveCPPFields(codeArr.id)}
					>
						--
					</button>
				</div>
			))}
			<br />
			<br />
			<h2>Java Test Cases Array:</h2>
			<br />
			{Jtestcases.map((inputField) => (
				<div key={inputField.id}>
					<p>Code:</p>
					<textarea
						rows="4"
						style={{ width: "100%" }}
						name="Jcode"
						placeholder="JCode"
						onChange={(event) => setJcode(event.target.value)}
					></textarea>
					<br />
					<p>Name:</p>
					<input
						name="Jname"
						placeholder="Jname"
						onChange={(event) => setJname(event.target.value)}
					/>{" "}
					<br />
					<p>Output:</p>
					<input
						name="Joutput"
						placeholder="Joutput"
						onChange={(event) => setJoutput(event.target.value)}
					/>
					&emsp;
					<button onClick={handleAddJFields}>++</button>
					&emsp;
					<button
						// disabled={inputFields.length === 1}
						onClick={() => handleRemoveJFields(codeArr.id)}
					>
						--
					</button>
				</div>
			))}
			<br />
			<br />
			<button onClick={() => submitHandler()}>Submit</button>
			{/* </form> */}
		</div>
	);
};

export default QuestionForm;
